import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface User {
    _id: string;
    email: string;
    name: string;
    role?: string;
    auth_provider: string;
    created_at: string;
    is_active: boolean;
    is_verified: boolean;
    assigned_date?: string | null;
    plivo_number?: string;
    status?: string;
    manager?: {
        id: string;
        name: string;
        email: string;
    };
    assingedUserId?: string[];
}

interface AllUsersResponse {
    success: boolean;
    message: string;
    data: User[];
}

export function useAllUsers() {
    return useQuery<AllUsersResponse>({
        queryKey: ['admin', 'all-users'],
        queryFn: async () => {
            const response = await api.get(`/api/v1/tapanel/all-users`);
            return response;
        },
        staleTime: 2 * 60 * 1000, // Cache for 2 minutes
    });
}
